<template>
  <div class="product-skin-experience" 
    v-if="customFields.skin_experience_image || customFields.skin_experience_title || customFields.skin_experience_copy"
  >
    <div class="product-skin-experience__container">
      <div class="product-skin-experience__image">
        <div class="product-skin-experience__image-wrapper">
          <div class="product-skin-experience__video-wrapper" v-if="customFields.skin_experience_video">
            <iframe ref="vimeoPlayer" class="product-skin-experience__video" :src="customFields.skin_experience_video" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>
            <transition name="fade">
              <div class="product-skin-experience__video-placeholder" v-if="!hidePlaceholder" @click="onPlay">
                <img :src="customFields.skin_experience_image" alt="">
                <icon name="play_button" :size="iconSize" />
              </div>
            </transition>
          </div>
          <image-ratio
            v-else
            :src="customFields.skin_experience_image"
            :alt="customFields.skin_experience_title"
            ratio="4:5"
            context="pdp"
          />
        </div>
      </div>
      <div class="product-skin-experience__content">
        <h2>{{customFields.skin_experience_title}}</h2>
        <div class="product-skin-experience__copy body-md" v-html="customFields.skin_experience_copy"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Player from '@vimeo/player';
import Icon from '@/scripts/components/basic/Icon.vue';
import ImageRatio from '@/scripts/components/basic/ImageRatio';

export default {
  name: "ProductSkinExperience",
  components: {
    ImageRatio,
    Icon
  },
  props: {
    customFields: Object,
  },
  data () {
    return {
      hidePlaceholder: false
    }
  },
  methods: {
    onPlay() {
      let thePlayer = new Player(this.$refs.vimeoPlayer);
      this.hidePlaceholder = true;
      thePlayer.play();
    }
  },
  computed: {
    iconSize() {
      return this.$mq === 'mobile' ? '68' : '86';
    }
  }
}
</script>

<style lang="scss">
.product-skin-experience {
  background-color: $color-white-tea-300;
  padding: 32px 16px 80px;

  @include tablet-up {
    padding: 64px 36px 92px;
  }

  &__container {
    margin: 0 auto;
    max-width: 2560px;
    @include tablet-up {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &__image {
    text-align: right;
  }

  &__image-wrapper {
    display: inline-block;
    width: 100%;
    max-width: 585px;
  }

  &__video-wrapper {
    padding-top: 56.25%;
    height: 0;
    position: relative;
  }

  &__video {
    position: absolute;
    left: 0;
    top: 0;
  }

  &__video-placeholder {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    cursor: pointer;

    img {
      height: 100%;
      width: 100%;
      object-fit: cover;
      object-position: center center;
    }

    .icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }

  &__content {
    justify-content: center;
    display: flex;
    flex-direction: column;
    text-align: center;
    padding-top: 34px;

    @include tablet-up {
      padding-top: 0;
      text-align: left;
    }

    h2 {
      margin-bottom: 30px;
      line-height: rem(34);

      @include tablet-up {
        margin-bottom: 126px;
        transform: translateX(-40px);
        line-height: rem(48);
      }
    }
  }

  &__copy {
    @include tablet-up {
      max-width: 350px;
      margin-left: 115px;
    }

    &,
    & * {
      color: $color-black-700;
      line-height: rem(23);
    }

    strong, b {
      @include body-md;
      font-weight: 600;
      padding-bottom: 8px;
    }

    p {
      margin-bottom: 12px;
    }
  }
}
</style>